import { notify } from 'utils/reduxUtils';

export const types = {
  RESET: 'modules/common/forms/materialWidget/rod/RESET',
  STOCK_REQUEST_ERROR:
    'modules/common/forms/materialWidget/rod/STOCK_REQUEST_ERROR',
  STOCK_REQUEST_SUBMIT:
    'modules/common/forms/materialWidget/rod/STOCK_REQUEST_SUBMIT',
  STOCK_REQUEST_SUCCESS:
    'modules/common/forms/materialWidget/rod/STOCK_REQUEST_SUCCESS',
  RECEIVE_RESULT: 'modules/common/forms/materialWidget/rod/RECEIVE_RESULT',
};

export const rodWidget = {
  reset: () => ({
    type: types.RESET,
  }),
};

export const receiveResult = ({ result }) => ({
  type: types.RECEIVE_RESULT,
  payload: { result },
});

export const stockRequest = {
  submit: ({
    barEnd,
    buffer,
    cutTolerance,
    cutWidth,
    diameter,
    length,
    manualBarCost,
    manualBarDiameter,
    manualBarLength,
    materialId,
    quantity,
    submitType,
  }) => ({
    type: types.STOCK_REQUEST_SUBMIT,
    payload: {
      barEnd,
      buffer,
      cutTolerance,
      cutWidth,
      diameter,
      length,
      manualBarCost,
      manualBarDiameter,
      manualBarLength,
      materialId,
      quantity,
      submitType,
    },
  }),
  success: () => ({
    type: types.STOCK_REQUEST_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.STOCK_REQUEST_ERROR,
      payload: error,
    }),
    'Stock Request Error',
  ),
};
